/**
* WARNING: This is an autogenerated file.  Do not edit by hand.
* To regenerate, run: pnpm i18n:extract-external-strings
*/

import {t, plural} from "@lingui/core/macro";
import type {MathInputStrings} from "@khanacademy/math-input/strings";
export const mathInputStrings = (): MathInputStrings => ({
    "mathInputBox": t`Math input box`,
    "fingerTap": t`Tap with one or two fingers to open keyboard`,
    "before": ({obj}) => t`before ${obj}`,
    "after": ({obj}) => t`after ${obj}`,
    "beginning of": ({obj}) => t`beginning of ${obj}`,
    "end of": ({obj}) => t`end of ${obj}`,
    "Baseline": t`Baseline`,
    "Superscript": t`Superscript`,
    "selected": ({obj}) => t`${obj} selected`,
    "no answer": t`no answer`,
    "nothing selected": t`nothing selected`,
    "nothing to the right": t`nothing to the right`,
    "nothing to the left": t`nothing to the left`,
    "block is empty": t`block is empty`,
    "nothing above": t`nothing above`,
    "labelValue": ({label, value}) => t`${label}: ${value}`,
    "plus": t({
        context: "A label for a 'plus' sign.",
        message: `Plus`,
    }),
    "minus": t({
        context: "A label for a 'minus' sign.",
        message: `Minus`,
    }),
    "negative": t({
        context: "A label for a 'negative' sign.",
        message: `Negative`,
    }),
    "times": t({
        context: "A label for a 'multiply' sign.",
        message: `Multiply`,
    }),
    "divide": t({
        context: "A label for a 'divide' sign.",
        message: `Divide`,
    }),
    "decimal": t({
        context: "A label for a 'decimal' sign (represented as '.' or ',').",
        message: `Decimal`,
    }),
    "percent": t({
        context: "A label for a 'percent' sign (represented as '%').",
        message: `Percent`,
    }),
    "cdot": t({
        context: "A label for a 'centered dot' multiplication sign (represented as '⋅').",
        message: `Multiply`,
    }),
    "equalsSign": t({
        context: "A label for an 'equals' sign (represented as '=').",
        message: `Equals sign`,
    }),
    "notEqualsSign": t({
        context: "A label for a 'not-equals' sign (represented as '≠').",
        message: `Not-equals sign`,
    }),
    "greaterThanSign": t({
        context: "A label for a 'greater than' sign (represented as '>').",
        message: `Greater than sign`,
    }),
    "lessThanSign": t({
        context: "A label for a 'less than' sign (represented as '<').",
        message: `Less than sign`,
    }),
    "greaterThanOrEqualToSign": t({
        context: "A label for a 'greater than or equal to' sign (represented as '≥').",
        message: `Greater than or equal to sign`,
    }),
    "lessThanOrEqualSign": t({
        context: "A label for a 'less than or equal to' sign (represented as '≤').",
        message: `Less than or equal to sign`,
    }),
    "fractionExpressionInNumerator": t({
        context: "A label for a button that creates a new fraction and puts the current expression in the numerator of that fraction.",
        message: `Fraction, with current expression in numerator`,
    }),
    "fractionExcludingExpression": t({
        context: "A label for a button that creates a new fraction next to the cursor.",
        message: `Fraction, excluding the current expression`,
    }),
    "customExponent": t({
        context: "A label for a button that will allow the user to input a custom exponent.",
        message: `Custom exponent`,
    }),
    "square": t({
        context: "A label for a button that will square (take to the second power) some math.",
        message: `Square`,
    }),
    "cube": t({
        context: "A label for a button that will cube (take to the third power) some math.",
        message: `Cube`,
    }),
    "squareRoot": t({
        context: "A label for a button that will allow the user to input a square root.",
        message: `Square root`,
    }),
    "cubeRoot": t({
        context: "A label for a button that will allow the user to input a cube root.",
        message: `Cube root`,
    }),
    "radicalWithCustomRoot": t({
        context: "A label for a button that will allow the user to input a radical with a custom root.",
        message: `Radical with custom root`,
    }),
    "leftParenthesis": t({
        context: "A label for a button that will allow the user to input a left parenthesis (i.e. '(')",
        message: `Left parenthesis`,
    }),
    "rightParenthesis": t({
        context: "A label for a button that will allow the user to input a right parenthesis (i.e. ')')",
        message: `Right parenthesis`,
    }),
    "naturalLog": t({
        context: "A label for a button that will allow the user to input a natural logarithm.",
        message: `Natural logarithm`,
    }),
    "logBase10": t({
        context: "A label for a button that will allow the user to input a logarithm with base 10.",
        message: `Logarithm with base 10`,
    }),
    "logCustomBase": t({
        context: "A label for a button that will allow the user to input a logarithm with a custom base.",
        message: `Logarithm with custom base`,
    }),
    "sine": t({
        context: "A label for a button that will allow the user to input a sine function.",
        message: `Sine`,
    }),
    "sin": t({
        context: "A label for a button that will allow the user to input a sine function (shorthand version).",
        message: `sin`,
    }),
    "cosine": t({
        context: "A label for a button that will allow the user to input a cosine function.",
        message: `Cosine`,
    }),
    "cos": t({
        context: "A label for a button that will allow the user to input a cosine function (shorthand version).",
        message: `cos`,
    }),
    "tangent": t({
        context: "A label for a button that will allow the user to input a tangent function.",
        message: `Tangent`,
    }),
    "tan": t({
        context: "A label for a button that will allow the user to input a tangent function (shorthand version).",
        message: `tan`,
    }),
    "pi": t({
        context: "A label for a button that will allow the user to input the mathematical constant pi (i.e., π)",
        message: `Pi`,
    }),
    "theta": t({
        context: "A label for a button that will allow the user to input the mathematical constant theta (i.e., θ)",
        message: `Theta`,
    }),
    "upArrow": t`Up arrow`,
    "rightArrow": t`Right arrow`,
    "downArrow": t`Down arrow`,
    "leftArrow": t`Left arrow`,
    "navOutOfParentheses": t`Navigate right out of a set of parentheses`,
    "navOutOfExponent": t`Navigate right out of an exponent`,
    "navOutOfBase": t`Navigate right out of a base`,
    "navIntoNumerator": t`Navigate right into the numerator of a fraction`,
    "navOutOfNumeratorIntoDenominator": t`Navigate right out of the numerator and into the denominator`,
    "navOutOfDenominator": t`Navigate right out of the denominator of a fraction`,
    "delete": t`Delete`,
    "dismiss": t({
        context: "A label for a button that will dismiss/hide a keypad.",
        message: `Dismiss`,
    }),
});
